import apiClient from './api';

// 用户管理服务
export const userService = {
  // 获取所有用户列表
  getAllUsers: async () => {
    try {
      const response = await apiClient.get('/users');
      return response.data.data || response.data; // 兼容不同的响应格式
    } catch (error) {
      console.error('获取用户列表失败:', error);
      throw error;
    }
  },

  // 获取单个用户信息
  getUserById: async (userId) => {
    try {
      const response = await apiClient.get(`/users/${userId}`);
      return response.data.data || response.data;
    } catch (error) {
      console.error('获取用户信息失败:', error);
      throw error;
    }
  },

  // 创建新用户
  createUser: async (userData) => {
    try {
      const response = await apiClient.post('/users', userData);
      return response.data.data || response.data;
    } catch (error) {
      console.error('创建用户失败:', error);
      throw error;
    }
  },

  // 更新用户信息
  updateUser: async (userId, userData) => {
    try {
      const response = await apiClient.put(`/users/${userId}`, userData);
      return response.data.data || response.data;
    } catch (error) {
      console.error('更新用户失败:', error);
      throw error;
    }
  },

  // 删除用户
  deleteUser: async (userId) => {
    try {
      const response = await apiClient.delete(`/users/${userId}`);
      return response.data.data || response.data;
    } catch (error) {
      console.error('删除用户失败:', error);
      throw error;
    }
  },

  // 获取用户头像
  getUserAvatar: async () => {
    try {
      const response = await apiClient.get('/users/profile/avatar');
      return response.data.data || response.data;
    } catch (error) {
      console.error('获取用户头像失败:', error);
      throw error;
    }
  },

  // 生成用户头像
  generateUserAvatar: async () => {
    try {
      const response = await apiClient.post('/users/profile/avatar/generate');
      return response.data.data || response.data;
    } catch (error) {
      console.error('生成用户头像失败:', error);
      throw error;
    }
  },

  // 更新用户头像
  updateUserAvatar: async (avatarUrl) => {
    try {
      const response = await apiClient.put('/users/profile/avatar', { avatarUrl });
      return response.data.data || response.data;
    } catch (error) {
      console.error('更新用户头像失败:', error);
      throw error;
    }
  }
}; 